import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/header-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-16dc2442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content d-flex flex-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none d-lg-block my-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    title: "GroupTrips.com",
    href: "/CMS/Dashboard"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "GroupTrips.com"
    })
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "user-box mt-2 flex-fill text-end"
}
const _hoisted_4 = { class: "u-name mb-1" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  title: "Go to Mail Menu",
  href: "/CMS/Dashboard"
}, "Main Menu", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" | ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.contact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("a", {
                href: '/' + _ctx.contact?.groupTripsUrl,
                target: "_blank"
              }, _toDisplayString(_ctx.contact?.organizationName), 9, _hoisted_5)
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" Email: " + _toDisplayString(_ctx.contact?.email) + " | ", 1),
              _createElementVNode("a", {
                href: '/' + _ctx.contact?.groupTripsUrl,
                target: "_blank",
                title: "View Public Pages"
              }, "Your Trips", 8, _hoisted_6),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("a", {
                title: "Logout from GroupTrips",
                href: "#",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, "Logout")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}